import { FileType, getExtensionsForFileType } from '../files/constants.js';

/**
 * File types accepted by the CAPA action evidence uploaders ("Evidences of
 * violation" and the "Remediation request form"). A curated subset of
 * images/documents plus every video format from the shared registry, so the
 * CAPA video set can never drift from the platform-wide one.
 */
export const CAPA_ACTION_ACCEPTED_FILE_TYPES: string[] = [
  '.jpg',
  '.jpeg',
  '.png',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.csv',
  ...getExtensionsForFileType(FileType.Video),
];

/** Maximum upload size for CAPA action evidence files (100 MB). */
export const CAPA_ACTION_MAX_FILE_SIZE = 100 * 1024 * 1024;

export const CAPA_ACTION_PRIORITY = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
} as const;

export const CAPA_ACTION_PRIORITY_LABELS: Record<
  keyof typeof CAPA_ACTION_PRIORITY,
  string
> = {
  A: 'Low',
  B: 'Moderate',
  C: 'Medium',
  D: 'High',
  E: 'Extreme',
};

export const CAPA_ACTION_TYPES = {
  CAP: 'CAP',
  CA: 'CA',
  PA: 'PA',
} as const;

// CAPA Workflow types
export const CAPA_WORKFLOW_TYPES = {
  EXTRACTION: 'EXTRACTION',
  CAPA_CLASSIFICATION: 'CAPA_CLASSIFICATION',
  CAPA_CAP_FILE_DATA_EXTRACTION: 'CAPA_CAP_FILE_DATA_EXTRACTION',
  EXTRACT_FINDINGS: 'EXTRACT_FINDINGS',
  CAPS_CREATION: 'CAPS_CREATION',
  CAPA_ACTIONS_GENERATION: 'CAPA_ACTIONS_GENERATION',
} as const;

export type CapaWorkflowType =
  (typeof CAPA_WORKFLOW_TYPES)[keyof typeof CAPA_WORKFLOW_TYPES];

export const CAPA_ACTION_STATUS = {
  TO_DO: 'TO_DO',
  IN_PROGRESS: 'IN_PROGRESS',
  BLOCKED: 'BLOCKED',
  IN_REVIEW: 'IN_REVIEW',
  CHANGES_REQUESTED: 'CHANGES_REQUESTED',
  DONE: 'DONE',
} as const;

export const CAPA_ACTION_COMPANY_TYPES = {
  CREATOR: 'CREATOR',
  OWNER: 'OWNER',
  COLLABORATOR: 'COLLABORATOR',
} as const;

export const CAPA_ACTION_USER_TYPES = {
  REPORTER: 'REPORTER',
  ASSIGNEE: 'ASSIGNEE',
  WATCHER: 'WATCHER',
} as const;

export type CapaActionUserType =
  (typeof CAPA_ACTION_USER_TYPES)[keyof typeof CAPA_ACTION_USER_TYPES];

export const CAPA_ACTION_RELATION_TYPES = {
  CHILD: 'CHILD',
  LINKED: 'LINKED',
} as const;

export const CAPA_ACTION_SOURCE_TYPES = {
  AUDIT: 'AUDIT',
  SLCP: 'SLCP',
} as const;

export const ENTITY_TAGS_ENTITY_TYPES = {
  FINDING: 'FINDING',
  CAPA: 'CAPA',
} as const;

export const ASSET_ACCESS_CONTROL_STATUSES = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const;

export const ASSET_ACCESS_CONTROL_TYPES = {
  AUDITS: 'AUDITS',
} as const;

export enum ShareAssessmentStatus {
  REQUESTED = 'REQUESTED',
  SHARED = 'SHARED',
}
